// extracted by mini-css-extract-plugin
export default {"next_order":"xv","recurringdis":"yv","reactivate_button":"zv","order__summary_title":"Av","order__summary_items":"Bv","order__summary_item":"Cv","order__summary_item_title":"Ev","order__summary_item_quantity":"Fv","order__item_separator":"Gv","discount":"Hv","promowrapper":"Iv"};
    if(module.hot) {
      // 1715188230660
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  